import React, { useState } from 'react'
import { Button, Container, Modal, Row } from 'react-bootstrap'
import Btn from '../../../../components/btns/Btn'

function VideoCta() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  return (
    <>
        <style>{`
            .video-cta-warpper .service__video_play { transform: none; left: auto; top: auto; margin: 0 auto 20px; cursor: pointer;}
            .video-cta-contact { background-size: cover; background-attachment: fixed; color: #fff; padding: 90px 0 140px !important; position: relative; z-index: 9; }
            .video-cta-contact::before { content: ''; position: absolute; width: 100%; height: 100%; background-color: var(--dark); top: 0; left: 0; opacity: .5; z-index: -1; }
            .video-cta-warpper h1, .video-cta-warpper h2 { font-size: 40px; margin-bottom: 16px; color: #fff !important;}
            .video-cta-warpper { font-size: 18px; }
            .video-cta-warpper  p { margin-bottom: 24px; color: #fff !important; }
            @media (max-width:767.98px) {
                .video-cta-contact { padding: 70px 0 120px !important; }
                .video-cta-warpper h1, .video-cta-warpper h2 { font-size: 36px; }
                .video-cta-warpper { font-size: 16px; }
            }
        `}</style>
        <div className="video-cta-contact section-padding" style={{backgroundImage: "url('../assets/images/videoCta/bg.jpg')"}}>
            <Container>
                <Row  data-aos="fade-up"> 
                    <div className="col-12 offset-xl-2 col-xl-8 offset-md-1 col-md-10 text-center">
                        <div className="video-cta-warpper">
                            <span className="service__video_play position-relative" onClick={handleShow}>
                                <i className="fa-solid fa-play"></i>
                            </span>  
                            <h1>Still You Need Our Support ?</h1>
                            <p>Don’t wait make a smart & logical quote here. It's pretty easy.</p>
                            <Btn type="default" value="Contact Us" />
                        </div>
                    </div>
                </Row>
            </Container>
        </div>
        

        {/* video modal  */}
        <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
            <Modal.Body className="p-2">
                <div className="about-video-box">
                    <Button variant="secondary" onClick={handleClose}>
                    <img src="../assets/images/close.svg" alt="" />
                    </Button>
                    <iframe
                    src="https://www.youtube.com/embed/YB9E8gkEEhE"
                    title="Xipe Tech UX Portfolio"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    ></iframe>
                </div>
            </Modal.Body>
        </Modal>
    </>
  )
}

export default VideoCta